import { TrackingType } from '../../../Commerce/TrackingType.csharp';
import { TrackingDetails } from '../../Tracking/VisitorIntelligence/TrackingDetails.csharp';
import { VisitorIntelligenceFacade } from '../../Tracking/VisitorIntelligence/VisitorIntelligenceFacade';
import { RecommendationsCache } from './RecommendationsCache';

export class RecommendationsService {
    public static RefreshRecommendations(trackingDetails: TrackingDetails) {
        VisitorIntelligenceFacade.Track(trackingDetails);
    }

    public static RefreshRecommendationsForWidget(trackingType: TrackingType) {
        VisitorIntelligenceFacade.Track({
            requireRecommendations: true,
            skipTracking: false,
            type: trackingType
        });
    }

    public static RefreshRecommendationsForSearch(term: string, productCodes: string[], totalResults: number) {
        VisitorIntelligenceFacade.TrackSearchResultsPage(term, productCodes, totalResults);
    }

    public static LoadRecommendations(widgetName: string, trackingType: TrackingType) {
        if (!RecommendationsCache.getRecommendations(widgetName)) {
            VisitorIntelligenceFacade.Track({
                requireRecommendations: true,
                skipTracking: false,
                type: trackingType
            });
        }
    }
}
